import { api } from 'src/api';
import { types } from 'mobx-state-tree';
import { createAsync } from 'src/utils/asyncModel';
const startBillAsync = createAsync(body => {
  return async function startBill(options) {
    const resp = await api.BillAutomationBills.startBill(body, options);
    return resp;
  };
});
const getBillAsync = createAsync(billId => {
  return async function getBill(options) {
    const resp = await api.BillAutomationBills.getBill(billId, options);
    return resp;
  };
});
const BillAutomationBillsApiStore = types.model('BillAutomationBillsApiStore', {
  startBillAsync,
  getBillAsync
});
export const billAutomationBillsApi = types.optional(BillAutomationBillsApiStore, {});